import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { quincyIlConfig } from "./data";

export default function QuincyIlPage() {
  return <CityPageTemplate config={quincyIlConfig} />;
}